import React from 'react'
import NewLocationRouter from './NewLocationRouter'

class HappyHourTaps extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            tapMenu: '',
            happyHours: '',
            location: '',
            locationShortId: '',
        }
    }
    refactorAbv = (abv) => {
        let number = parseFloat(abv)
        return number
    }

    getTapMenu = (menuId) => {
        const url = `https://pl-api-dev.herokuapp.com/api/untappd/menu/${menuId}`
        return fetch(url)
        .then(res => res.json())
        .then(data => {
            console.log(data)
            let menu = data.menu.sections[0].items
            this.setState({tapMenu: menu})
        })
        .catch(err => err)
    }
    getHappyHour = (location) => {
        
        const getLocationId = (location) => {
            if (location === 'pl1') {
                return '5c2bbcfb53352c57e74314ff'
            } else if (location === 'pl2') {
                return '5c2bbdff53352c57e7431500'
            } else if (location === 'pl3') {
                return '5c2bbffc53352c57e7431501'
            } else if (location === 'pl4') {
                return '5c2bc17e53352c57e7431502'
            } else if (location === 'pl5') {
                return '5c2bc31653352c57e7431503'
            } else if (location === 'pl6') {
                return '5c2bc3b553352c57e7431504'
            } else if (location === 'pl7') {
                return '5c2bc47d53352c57e7431505'
            } else if (location === 'pl8') {
                return '5c2bc51b53352c57e7431506'
            } else if (location === 'pl9') {
                return '5c2bc75953352c57e7431507'
            }
        }
        this.setState({locationShortId: location})
        return getLocationId(location)
    }

    filterBrewery = (brewery) => {
        console.log(brewery)
        if (brewery.includes("Brewery")){
            return brewery.replace("Brewery", "")
        } else if (brewery.includes("Brewing") || brewery.includes('Company') || brewery.includes('Co.') || brewery.includes("Cooperative")){
            return brewery.replace('Brewing', "").replace('Company', "").replace('Co.', "").replace("Cooperative", "COOP").replace('Co ', "")
        } else if (brewery.includes('Brew Labs')){
            return brewery.replace('Brew Labs', "")
        }  else if (brewery.includes('Werks')){
            return brewery.replace("Werks", "")
        } else if (brewery.includes("Beer")){
            return (brewery.replace("Beer", ""))
        } else if (brewery.includes("Anheuser-Busch")){
            return "AB InBev"
        } 
            else {
            return brewery
        }
    }
    refactorAbv = (abv) => {
        let number = parseFloat(abv)
        return number
    }
    filterStyle = (style) => {
        
        if (style === "IPA - American"){
            return "IPA"
        } else if (style === "Stout - Milk / Sweet"){
            return "Stout"
        } else if (style === "Sour - Fruited Berliner Weisse"){
            return "Sour"
        }  else if (style === "IPA - New England / Hazy"){
            return "Hazy IPA"
        }  else if (style === "Pale Ale - New England / Hazy"){
            return "Hazy Pale"
        } else if (style === "Pale Ale - English" || style === "Pale Ale - American"){
            return "Pale Ale"
        } else if (style.includes('Lager')){
            return "Lager"
        } else if (style.includes('Pilsner')){
            return "Pilsner"
        } else if (style.includes("Cider - Traditional")){
            return "Cider"
        } else if (style.includes("Stout - American")){
            return "Stout"
        } else if (style.includes("Stout - Russian Imperial")){
            return "Imperial Stout"
        } else if (style.includes("Brown Ale")){
            return "Brown Ale"
        } else if (style.includes("Wheat Beer - Witbier / Blanche")){
            return "Witbier"
        } else if (style.includes("Non-Alcoholic Beer")){
            return "NA Beer"
        }
        
            else {
            return style
        }
    }
   
    filterItem = (item) => {
        if (item.includes("Pilsner Style Beer")){
            return "Pilsner"
        } else if (item.includes("Bent Paddle Cold Press Nitro")){
            return "Cold Press Nitro"
        } else if (item.includes("Jameson Barrel Aged Brown Ale")){
            return "Jameson Barrel Aged"
        } else if (item.includes("Gravity Well")){
            return "Gravity Well"
        } else if (item.includes("Castle Cream Ale")){
            return "Cream Ale"
        } else if (item.includes("Lollygagger Pale Ale")){
            return "Lollygagger"
        } else if (item.includes("Pyro American Pale Ale")){
            return "Pyro American"
        } else if (item.includes("Bent Hop | India Pale Ale")){
            return "Bent Hop"
        } else if (item.includes("Cold Press Black | Coffee Ale")){
            return "Cold Press Black"
        } else if (item.includes("Venture Pils | Pilsener Lager")){
            return ("Venture Pils")
        }
        
        else {
            return item
        }
    }
    getHappyHourMenu = (locId) => {
        let locationId = this.getHappyHour(locId)
        const url = `https://beta.pizzaluce.com/api/location/${locationId}/full`
        fetch(url)
        .then(res => res.json())
        .then(data => {
            let promos = data.location.promos
            let locationData = data.location
            this.setState({happyHours: promos, location: locationData})
        })
        .catch(err => err)
    }
    

    
    componentDidMount(){
        const locationId = this.props.match.params.location
        const menuId = this.props.match.params.tapsId
        this.getHappyHourMenu(locationId)
        this.getTapMenu(menuId)
    }
    render() {
        console.log(this.state)
        return (
            <>
                <NewLocationRouter
                    locationShortId={this.state.locationShortId}
                    location={this.state.location}
                    tapMenu={this.state.tapMenu}
                    happyHours={this.state.happyHours}
                    filterBrewery={this.filterBrewery}
                    refactorAbv={this.refactorAbv}
                    filterStyle={this.filterStyle}
                    filterItem={this.filterItem}
                />
            </>
        )
    }
}
export default HappyHourTaps
